/**
 * Try utilizing a Backbone Model since still using Backbone, ugh
 * Attributes here will be all server
 * These are actually and OCR note in the database.
 * Now used to print the page text overlays -- TODO: a candidate for removal ( everything at doc level now -- see DocumentTextModel )
**/

var Backbone = require('backbone'),
    PositionTextUiModel = require('./uiModel'),
    Zones = require('./zones'),
    Zone = require('../../positionalTextModels/textAreaModels/zone'),
    Lines = require('./lines'),
    Line = require('../../positionalTextModels/textAreaModels/line'),
    Words = require('./words'),
    ShapeUtils = require('../../../../canvas/models/shapeUtils');


module.exports = Backbone.Model.extend({

    constructor: function( attrs, options ) {

        this.zones = new Zones();
        this.lines = new Lines();
        this.words = new Words();

        this.uiModel = new PositionTextUiModel();

        Backbone.Model.apply( this, arguments );

    },

    /**
     * Return only the page object in the 'pages array '-- there will always be one ( it is a page ).
     * Could make it easier to work with server side.
     */

    defaults: {
        version: null,
        pageNumber: null,
        pageId: null,

        'ocr-vers': null,
        'app-vers': null,
        dpix: null,
        dpiy: null,
        sizex: null,
        sizey: null,
        language: null
    },


    //
    /**
     * Return the attrs hash to be set on the model
     * Fuck all these Backbone Model's -- extra overhead ... only good for using approp BB views
     * This is candidate for refactor -- parsed and looped through again at the Doc Level now.
     * ( And now not all attributes set on the models on parse so we loop again ( setDerivedBoxes )
     */

    parse: function( attrs, options ) {

        var pageAttrs = attrs.pages[0],
            pageNumber = options.pageNumber,
            pageId = options.pageId,
            ocr_xdpi = pageAttrs.dpix,

            //dpiy = pageAttrs.dpiy, // note: now note using dpiy anywhere

            fddPgOriginalImageProperties = options.fddPageOriginalImageProperties,
            fdd_xdpi = fddPgOriginalImageProperties.originalHDPI, // note: not using vDPI

            ocrDpiDifferentThanFddDpi = fdd_xdpi !== ocr_xdpi, // leaving to emphasize the logic, but currently not used

            box_px_adjustment = this.uiModel.get('BOX_PX_ADJUSTMENT');


        var nLines = 0;
        var nWords = 0;

        var zones = pageAttrs.textzones;


        for (var z in zones) {

            z = parseInt(z);
            var zone = zones[z];
            var nWordsInZone = 0;

            var zoneModel = new Zone( zone, {
                parse: true,
                page_level_id: z,
                pageNumber: pageNumber,
                pageId: pageId,
                ocr_xdpi: ocr_xdpi,
                fdd_xdpi: fdd_xdpi
            });

            // Now only take the box_px_adjustment into account -- not taking into acct other zones/lines
            zoneModel.setDerivedBoxes( box_px_adjustment, fdd_xdpi );

            this.zones.add( zoneModel );

            var lines = zone.lines;

            for (var l in lines) {

                l = parseInt(l);

                var line = lines[l];

                var lineModel = new Line( line, {
                    parse: true,
                    page_level_id: nLines,
                    pageLevelZoneId: z,
                    pageLevelZoneLineId: l,
                    pageNumber: pageNumber,
                    pageId: pageId,
                    ocr_xdpi: ocr_xdpi,
                    fdd_xdpi: fdd_xdpi
                });

                // Now only take the box_px_adjustment into account -- not taking into acct other zones/lines
                lineModel.setDerivedBoxes( box_px_adjustment, fdd_xdpi );

                this.lines.add( lineModel );

                this.zones.at(z).addPageLevelLineId( nLines );

                var words = line.words;

                for (var w in words) {

                    var word = words[w];

                    this.words.add( word, {

                        parse: true,
                        page_level_id: nWords,
                        pageLevelZoneId: z,
                        pageLevelLineId: nLines,
                        pageLevelLineWordId: parseInt(w),
                        pageLevelZoneWordId: nWordsInZone,
                        pageLevelZoneLineId: l,
                        pageNumber: pageNumber,
                        pageId: pageId,

                        ocr_xdpi: ocr_xdpi,
                        fdd_xdpi: fdd_xdpi

                    });

                    this.lines.at( nLines ).addPageLevelWordId( nWords );
                    this.zones.at( z ).addPageLevelWordId( nWords );

                    nWords++;
                    nWordsInZone++;

                }

                nLines++;

            }

        }


        /**
         * Set derived dimension for words which requires calcuations to be done after the first loop ( next word, line ).
         * For now nothing special with text areas or zones other than padding ( above ); maybe later we do those too.
         * Definitely more efficient way to accomplish -- eg combo with looping when need to parse in document ...
         * For Lines -- important: these in page order can be adjacent to each other, so we need to concern ourselves
         * with those in the same zone ( as we do with words on the lines ).
         */
        this.words.each( function( word, i ) {

            var pageLevelZoneId = word.get('pageLevelZoneId');
            var pageLevelLineId = word.get('pageLevelLineId');

            // --- Lines ---
            var line = this.lines.at(  pageLevelLineId );
            var previousLine = this.lines.at( pageLevelLineId - 1 ); // ( undefined if not returned )
            var nextLine = this.lines.at( pageLevelLineId + 1);

            var prevLineInZone = previousLine && previousLine.get( 'pageLevelZoneId' ) === pageLevelZoneId
                ? previousLine
                : undefined;

            var nextLineInZone = nextLine && nextLine.get('pageLevelZoneId') === pageLevelZoneId
                ? nextLine
                : undefined;

            // --- Words ---
            var prevWd = this.words.at( i - 1 );
            var nextWd = this.words.at( i + 1 );

            var prevWordOnLine = prevWd && prevWd.get('pageLevelLineId') === pageLevelLineId
                ? prevWd
                : undefined;

            var nextWordOnLine = nextWd && nextWd.get('pageLevelLineId') === pageLevelLineId
                ? nextWd
                : undefined;

            word.setDerivedBoxes(
                box_px_adjustment, fdd_xdpi, line, prevLineInZone, nextLineInZone, prevWordOnLine, nextWordOnLine
            );


        }, this);



        var modelAttrs = _.extend( {}, pageAttrs , { // don't need to put pageAttrs on here again ...
            version: attrs.version,
            pageNumber: options.pageNumber, // maybe we want a reference to the parent model ?
            pageId: options.pageId
        });

        delete modelAttrs.textzones;

        return modelAttrs;

    },

    getZones: function() {
        return this.zones;
    },

    getLines: function() {
        return this.lines;
    },

    getWords: function() {
        return this.words;
    },

    getFont: function() {
        return this.uiModel.get('font');
    },

    // Now used in parsing at the doc level from these
    getWord: function( pageLevelWordId ) {

        return this.words.findWhere({ page_level_id: pageLevelWordId });

    },

    // Now used in parsing at the doc level from these
    // Now not used -- used as doc level parse ( as long as still using this obj )
    getLine: function( pageLevelLineId ) {
        return this.lines.findWhere( { page_level_id: pageLevelLineId } );
    },

    /**
     * TODO: this is not page-line-ids -- can't use get unless pass in the doc level id
     *  Could have both ...
     * No longer used ...
     */
    getWordsOfLine: function( pageLevelLineId ) {


        var line = this.getLine( pageLevelLineId );

        return _.map( line.pgLevelWordIds, function( wid ) {

           // return this.words.findWhere(wid); // add these may also blow up now with id and .get
            return this.words.findWhere({ page_level_id: wid });

        }, this );

    },

    /**
     * Convenience if has access to line model -- now unused but would need to change
     * No longer used
     */
    getWordModelsOfLine: function( lineModel ) {

        return _.map( lineModel.pgLevelWordIds, function( wid ) {
           return this.words.get(wid);
        }, this);

    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/models/page/pgPositionalTextModel/model.js
 ** module id = 345
 ** module chunks = 0
 **/